import { z } from 'zod';

export const baseIndicatorItemSchema = z.object({
  note: z.string().nullish(),
  link: z.union([z.literal(''), z.literal(null), z.string().trim().url()]),
  newFile: z.custom<File>().nullable(),
  year: z.number().nullable(),
  points: z.number().nullish(),
  file: z
    .object({
      title: z.string().nullable(),
    })
    .nullish(),
  indicatorType: z.enum([
    'FREE_ANSWER',
    'NUMBER',
    'BOOLEAN',
    'INTERVAL',
    'SELECT_ABSTRACT',
    'SELECT_ARTICLE',
    'SELECT_BOOK',
    'SELECT_CHAPTER',
    'SELECT_COURSE',
    'SELECT_COMMITTEE',
    'SELECT_PROJECT',
    'SELECT_PATENT',
    'SELECT_TRANSLATION',
    'SELECT_PROCEEDING',
    'SELECT_AWARD',
    'SELECT_CITATION',
  ]),
});

export const freeIndicatorItemSchema = baseIndicatorItemSchema.extend({
  activityDescription: z.string().min(3),
});

export const booleanIndicatorItemSchema = baseIndicatorItemSchema.extend({});

export const numberIndicatorItemSchema = baseIndicatorItemSchema.extend({
  number: z.coerce.number().min(0),
});

export const intervalIndicatorItemSchema = baseIndicatorItemSchema.extend({
  interval: z.object({
    startYear: z.number().min(1900),
    endYear: z
      .number()
      .min(1900)
      .transform(no => (isNaN(no) ? undefined : no))
      .optional(),
    activity: z.string().min(3),
  }),
});

export const selectSchema = z.object({
  id: z.coerce.number(),
  title: z.string().nullish(),
});

export const courseIndicatorItemSchema = baseIndicatorItemSchema.extend({
  course: selectSchema,
});

export const abstractIndicatorItemSchema = baseIndicatorItemSchema.extend({
  abstractItem: selectSchema,
});

export const articleIndicatorItemSchema = baseIndicatorItemSchema.extend({
  article: selectSchema,
});

export const bookIndicatorItemSchema = baseIndicatorItemSchema.extend({
  book: selectSchema,
});

export const translationIndicatorItemSchema = baseIndicatorItemSchema.extend({
  translation: selectSchema,
});

export const proceedingIndicatorItemSchema = baseIndicatorItemSchema.extend({
  proceeding: selectSchema,
});

export const awardIndicatorItemSchema = baseIndicatorItemSchema.extend({
  award: selectSchema,
});

export const citationIndicatorItemSchema = baseIndicatorItemSchema.extend({
  citation: selectSchema,
});

export const chapterIndicatorItemSchema = baseIndicatorItemSchema.extend({
  chapter: selectSchema,
});

export const committeeIndicatorItemSchema = baseIndicatorItemSchema.extend({
  committee: selectSchema,
});

export const projectIndicatorItemSchema = baseIndicatorItemSchema.extend({
  project: selectSchema,
});

export const patentIndicatorItemSchema = baseIndicatorItemSchema.extend({
  patent: selectSchema,
});

export type BaseIndicatorItemSchema = z.infer<typeof baseIndicatorItemSchema>;
